import React, { VFCX } from 'react';
import styled from '@emotion/styled';

import { Chart, Qualifications, Skills } from '.';

const Component: VFCX = ({ className }) => (
  <div className={className}>
    <Qualifications />
    <Skills />
    <div className='container'>
      <div className='item'>
        <Chart />
      </div>
      <div className='item'></div>
    </div>
  </div>
);

const StyledComponent = styled(Component)`
  flex: 3 1 auto;
  max-width: 1000px;

  color: #fff;
  padding: 2rem;
  background-color: var(--color-secondary-light);

  table th {
    color: #fff;
    font-weight: 600;
    font-size: 100%;
  }
  table td {
    color: #fff;
    font-size: 100%;
  }

  & > .title {
    color: var(--color-secondary-dark);
    padding: 16px;
    border-bottom: 1px solid #fff;
  }

  & > .container {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    & > .item {
      width: 50%;
      margin: 20px;
      background-color: rgba(255, 255, 255, 0.7);
    }
  }
`;

export default StyledComponent;
